import { heapTrackProperties } from '@m/utils/heap';

export const SCANNED_NATIVE = 'native';
export const SCANNED_ACTIVE_VISIT_PAGE = 'activeVisitPage';

type ScanLocation = typeof SCANNED_NATIVE | typeof SCANNED_ACTIVE_VISIT_PAGE;

export const trackValidationScan = ({
  validationScanSource,
  pendingValidationUuid,
}: {
  pendingValidationUuid: string;
  validationScanSource: ScanLocation;
}) => {
  heapTrackProperties('Validation Scanned', {
    validationScanSource,
    pendingValidationUuid,
  });
};

export const trackValidationResponse = ({
  appliedValidationSuccess,
  appliedValidationUuid,
  attemptedValidationId,
  appliedValidationTransactionId,
  appliedValidationSiteId,
  appliedValidationErrorMessage,
  isParkingPassValidation = false,
}: {
  appliedValidationErrorMessage?: string;
  appliedValidationSiteId: number | 'null';

  appliedValidationSuccess: boolean;
  appliedValidationTransactionId: number | 'null';
  appliedValidationUuid?: string;
  /** can be success or failed validation id. we don't always have failed validationIds */
  attemptedValidationId?: number;
  isParkingPassValidation?: boolean | null;
}) => {
  heapTrackProperties('Validation Scan Response', {
    appliedValidationSuccess: String(appliedValidationSuccess),
    appliedValidationUuid,
    attemptedValidationId,
    appliedValidationTransactionId,
    appliedValidationSiteId,
    appliedValidationErrorMessage,
    isParkingPassValidation: String(isParkingPassValidation),
  });
};

export const trackPassValidationInput = ({
  appliedValidationSuccess,
  enteredSignCode = false,
  scannedQrCode = false,
  validationUuid,
}: {
  appliedValidationSuccess: boolean;
  enteredSignCode: boolean;
  scannedQrCode: boolean;
  validationUuid: string;
}) => {
  heapTrackProperties('Parking Pass Validation Input', {
    appliedValidationSuccess: String(appliedValidationSuccess),
    enteredSignCode: String(enteredSignCode),
    scannedQrCode: String(scannedQrCode),
    validationUuid,
  });
};
